<div class="associative-login-wrapper">
  <!-- Background Grid -->
  <div class="bg-grid">
    <div class="bg-overlay"></div>
    <div class="grid-images">
      <img src="/images/mainbg.png" alt="bg">
    </div>
  </div>

  <!-- Signup Modal -->
  <div class="login-modal-container">
    <div class="login-card">
      <div class="brand-logo">
        <h1>Evoryn<span class="tm">™</span></h1>
      </div>

      <div class="login-form-section">
        <h2 class="login-title">Basic Details</h2>

        <form class="login-form" [formGroup]="SignupForm" (ngSubmit)="onSubmit()">
          <!-- First Name -->
          <div class="input-wrapper"
            [class.error]="SignupForm.get('firstName')?.touched && SignupForm.get('firstName')?.invalid">
            <i class="input-icon fa-regular fa-user"></i>
            <input type="text" class="custom-input" placeholder="First Name" formControlName="firstName" required />
          </div>

          <!-- Last Name -->
          <div class="input-wrapper"
            [class.error]="SignupForm.get('lastName')?.touched && SignupForm.get('lastName')?.invalid">
            <i class="input-icon fa-regular fa-user"></i>
            <input type="text" class="custom-input" placeholder="Last Name" formControlName="lastName" required />
          </div>

          <!-- Email Address -->
          <div class="input-wrapper"
            [class.error]="SignupForm.get('email')?.touched && SignupForm.get('email')?.invalid">
            <i class="input-icon fa-regular fa-envelope"></i>
            <input type="email" class="custom-input" placeholder="Email Address" formControlName="email" required />
          </div>

          <!-- Phone Number (Read-only) -->
          <div class="input-wrapper">
            <i class="input-icon fa-solid fa-phone"></i>
            <input type="text" class="custom-input" placeholder="Phone Number" formControlName="phoneNumber" readonly />
          </div>

          <!-- Address -->
          <div class="input-wrapper"
            [class.error]="SignupForm.get('address')?.touched && SignupForm.get('address')?.invalid">
            <i class="input-icon fa-solid fa-location-dot"></i>
            <input type="text" class="custom-input" placeholder="Address" formControlName="address" required />
          </div>

          <!-- Location Row 1: Country & State -->
          <div class="form-row">
            <div class="input-wrapper"
              [class.error]="SignupForm.get('countryID')?.touched && SignupForm.get('countryID')?.invalid">
              <i class="input-icon fa-solid fa-globe"></i>
              <div class="custom-dropdown-container">
                <div class="custom-input custom-select" (click)="toggleDropdown('country', $event)">
                  {{ getCountryName(SignupForm.value.countryID) }}
                </div>
                <div class="custom-dropdown-menu" *ngIf="activeDropdown === 'country'" (click)="$event.stopPropagation()">
                  <div class="search-box">
                    <input type="text" placeholder="Search Country..." (input)="filterList('country', $event)">
                  </div>
                  <ul class="options-list">
                    <li *ngFor="let c of filteredCountries" (click)="selectCountry(c)">{{ c.countryName }}</li>
                    <li *ngIf="filteredCountries.length === 0" class="no-results">No results found</li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="input-wrapper"
              [class.error]="SignupForm.get('stateID')?.touched && SignupForm.get('stateID')?.invalid">
              <i class="input-icon fa-solid fa-map"></i>
              <div class="custom-dropdown-container">
                <div class="custom-input custom-select" (click)="toggleDropdown('state', $event)">
                  {{ getStateName(SignupForm.value.stateID) }}
                </div>
                <div class="custom-dropdown-menu" *ngIf="activeDropdown === 'state'" (click)="$event.stopPropagation()">
                  <div class="search-box">
                    <input type="text" placeholder="Search State..." (input)="filterList('state', $event)">
                  </div>
                  <ul class="options-list">
                    <li *ngFor="let s of filteredStates" (click)="selectState(s)">{{ s.stateName }}</li>
                    <li *ngIf="filteredStates.length === 0" class="no-results">No results found</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- Location Row 2: City & Pincode -->
          <div class="form-row">
            <div class="input-wrapper"
              [class.error]="SignupForm.get('cityID')?.touched && SignupForm.get('cityID')?.invalid">
              <i class="input-icon fa-solid fa-city"></i>
              <div class="custom-dropdown-container">
                <div class="custom-input custom-select" (click)="toggleDropdown('city', $event)">
                  {{ getCityName(SignupForm.value.cityID) }}
                </div>
                <div class="custom-dropdown-menu" *ngIf="activeDropdown === 'city'" (click)="$event.stopPropagation()">
                  <div class="search-box">
                    <input type="text" placeholder="Search City..." (input)="filterList('city', $event)">
                  </div>
                  <ul class="options-list">
                    <li *ngFor="let c of filteredCities" (click)="selectCity(c)">{{ c.cityName }}</li>
                    <li *ngIf="filteredCities.length === 0" class="no-results">No results found</li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="input-wrapper"
              [class.error]="SignupForm.get('pincodeID')?.touched && SignupForm.get('pincodeID')?.invalid">
              <i class="input-icon fa-solid fa-hashtag"></i>
              <div class="custom-dropdown-container">
                <div class="custom-input custom-select" (click)="toggleDropdown('pincode', $event)">
                  {{ getPincodeName(SignupForm.value.pincodeID) }}
                </div>
                <div class="custom-dropdown-menu" *ngIf="activeDropdown === 'pincode'" (click)="$event.stopPropagation()">
                  <div class="search-box">
                    <input type="text" placeholder="Search Pincode..." (input)="filterList('pincode', $event)">
                  </div>
                  <ul class="options-list">
                    <li *ngFor="let p of filteredPincodes" (click)="selectPincode(p)">{{ p.pincode }}</li>
                    <li *ngIf="filteredPincodes.length === 0" class="no-results">No results found</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- Location Row 3: Area -->
          <div class="input-wrapper"
            [class.error]="SignupForm.get('areaID')?.touched && SignupForm.get('areaID')?.invalid">
            <i class="input-icon fa-solid fa-map-pin"></i>
            <div class="custom-dropdown-container">
              <div class="custom-input custom-select" (click)="toggleDropdown('area', $event)">
                {{ getAreaName(SignupForm.value.areaID) }}
              </div>
              <div class="custom-dropdown-menu" *ngIf="activeDropdown === 'area'" (click)="$event.stopPropagation()">
                <div class="search-box">
                  <input type="text" placeholder="Search Area..." (input)="filterList('area', $event)">
                </div>
                <ul class="options-list">
                  <li *ngFor="let a of filteredAreas" (click)="selectArea(a)">{{ a.areaName }}</li>
                  <li *ngIf="filteredAreas.length === 0" class="no-results">No results found</li>
                </ul>
              </div>
            </div>
          </div>

          <!-- Social Media Inputs -->
          <div class="input-wrapper">
            <i class="input-icon fa-brands fa-instagram"></i>
            <input type="text" class="custom-input" placeholder="Instagram" formControlName="instagram" />
          </div>

          <div class="input-wrapper">
            <i class="input-icon fa-brands fa-telegram"></i>
            <input type="text" class="custom-input" placeholder="Telegram" formControlName="telegram" />
          </div>

          <div class="input-wrapper">
            <i class="input-icon fa-brands fa-whatsapp"></i>
            <input type="text" class="custom-input" placeholder="Whatsapp" formControlName="whatsapp" />
          </div>

          <div class="input-wrapper">
            <i class="input-icon fa-brands fa-facebook-f"></i>
            <input type="text" class="custom-input" placeholder="Facebook" formControlName="facebook" />
          </div>

          <!-- Description -->
          <div class="input-wrapper description-wrapper"
            [class.error]="SignupForm.get('description')?.touched && SignupForm.get('description')?.invalid">
            <i class="input-icon fa-regular fa-file-lines"></i>
            <textarea class="custom-input custom-textarea" placeholder="Description" formControlName="description"
              rows="3"></textarea>
          </div>

          <!-- Terms Checkbox -->
          <div class="terms-wrapper"
            [class.error]="SignupForm.get('isTermsAgreed')?.touched && SignupForm.get('agreeTerms')?.invalid">
            <label class="checkbox-container">
              <input type="checkbox" formControlName="isTermsAgreed" id="agreeTerms" />
              <span class="checkmark"></span>
              <span class="checkbox-text">I agree to the Terms & Conditions</span>
            </label>
          </div>

          <!-- Submit Button -->
          <button type="submit" class="submit-btn">
            Submit
          </button>
        </form>
      </div>
    </div>
  </div>
</div>